import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 20v-16h-3a4 4 0 0 0 -4 4v8a4 4 0 0 0 4 4h3","key":"svg-0"}],["path",{"d":"M14 20v-16h3a4 4 0 0 1 4 4v8a4 4 0 0 1 -4 4h-3","key":"svg-1"}],["path",{"d":"M16.5 15.5a1 1 0 1 0 2 0a1 1 0 1 0 -2 0","fill":"currentColor","key":"svg-2"}],["path",{"d":"M5.5 8.5a1 1 0 1 0 2 0a1 1 0 1 0 -2 0","fill":"currentColor","key":"svg-3"}]]

const IconDeviceNintendo = createReactComponent('outline', 'device-nintendo', 'DeviceNintendo', __iconNode);

export default IconDeviceNintendo;